export const AUTOMOTIVE_GROUP_LANDING_CONFIG = {
  WHATSAPP_GROUP_URL: '[https://chat.whatsapp.com/HUPIpuP5Kw1KHHCkJcaYtW]',
  META_PIXEL_ID: '1035179145893859',
  GA_MEASUREMENT_ID: '',
};

export const DEVELOPMENT_WHATSAPP_URL = 'https://www.whatsapp.com/';

